import { useEffect, useState } from "react";
import { API } from "@/App";
import { toast } from "sonner";
import { Link2, Package, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

const fmt = (d) => d.split("-").reverse().join(".");

export const MemberPendingNotice = ({ member, businessId, onChanged, onSell }) => {
  const [req, setReq] = useState(null);
  useEffect(() => {
    if (!member?.member_id || !businessId) return;
    fetch(`${API}/businesses/${businessId}/package-requests`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : [])).then((rows) => setReq(rows.find((x) => x.member_id === member.member_id) || null)).catch(() => {});
  }, [member?.member_id, businessId, member?.updated_at]);
  const dismiss = async () => {
    const r = await fetch(`${API}/members/${member.member_id}/link-approve`, { method: "POST", credentials: "include" });
    if (r.ok) { toast.success("Farklı kişi olarak işaretlendi"); onChanged(); } else toast.error("İşlem başarısız");
  };
  const dup = member?.possible_duplicate_of?.length > 0;
  if (!dup && !req) return null;
  return (
    <div className="space-y-2" data-testid="member-pending-notice">
      {dup && (
        <div className="flex flex-wrap items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
          <Link2 className="w-4 h-4 text-amber-600" />
          <p className="text-sm text-amber-900 flex-1 min-w-[220px]"><b>Olası tekrar kayıt:</b> Bu kişi linkten kayıt oldu ve aynı ad-soyadda başka bir üyeniz var. Aynı kişiyse Üyeler sayfasındaki "Olası Tekrar Kayıt" listesinden birleştirebilirsiniz.</p>
          <Button size="sm" variant="outline" className="rounded-lg h-8" onClick={dismiss} data-testid="member-duplicate-dismiss"><Check className="w-4 h-4 mr-1" />Farklı kişi</Button>
        </div>
      )}
      {req && (
        <div className="flex flex-wrap items-center gap-3 rounded-xl border border-orange-200 bg-orange-50 px-4 py-3">
          <Package className="w-4 h-4 text-orange-600" />
          <p className="text-sm text-orange-900 flex-1 min-w-[220px]"><b>Paket talebi:</b> Paketsiz rezervasyonu var ({req.requested.map((r) => `${fmt(r.date)} ${r.start_time}`).join(", ")}). Paket satınca bu rezervasyonlar pakete otomatik bağlanır.</p>
          <Button size="sm" className="rounded-lg bg-orange-600 hover:bg-orange-700 h-8" onClick={onSell} data-testid="member-pending-sell">Paket Sat</Button>
        </div>
      )}
    </div>
  );
};
